<app-topbar></app-topbar>
<div class="container sccsmaindiv">
    <div class="common text-center">
        <div class="sccssimgdiv">
            <img src="assets/images/bloomview-icon.png" class="sccssimg">					
        </div>
        <div class="common sccsstextdiv">
            <h4 class="sccspghdng">Success !</h4>
            <p class="boxpara_bold">Thank you for your payment and welcome to Bloomview! <br>
                You can start using your new app right away. </p>
            <p><a routerLink="/subscriptions" href="#" class="boxpara_bold clrblue">Manage your Stores and Licenses</a></p>
        </div>
    </div>
</div>